/* eslint-disable @typescript-eslint/no-unused-vars */
import { Settings } from "react-slick";
import { useMediaQuery } from "@mui/material";
import { useScreenSize } from "./Theme";

const { desktop, mobile } = useScreenSize();

export const HEIGHT_DOT_ROW = 20;

// React-Slick用の設定(PC・モバイル共通)
export const ReactSlickSetting: Settings = {
    arrows: desktop, // スライドの左右にある矢印の表示・非表示
    dots: !desktop, // ドットの表示・非表示
    infinite: false, // スライダーを無限にスライドできるか
    slidesToShow: 1, // 一度に表示するスライドの数
    slidesToScroll: 1, // 一度のスクロールで何枚スライドするか
    swipeToSlide: true, // ドラッグ、スワイプでのスクロールを有効にするか
    variableWidth: true,
};

export const calcDotsHeight = (baseHeight: number, itemsNum: number, rows: number) => {
    const matches2: boolean = useMediaQuery(() => "@media (max-width: 523px)");
    const matches3: boolean = useMediaQuery(() => "@media (min-width: 524px) and (max-width: 700px)");
    const matches4: boolean = useMediaQuery(() => "@media (min-width: 701px) and (max-width: 1000px)");

    // ドット数：(アイテムの総件数 ÷ 行数) + 1(最終ページ)
    const dotsNum = Math.floor(itemsNum / rows) + 1;

    // 1行あたりのドット数を設定する。
    let dotsPerRow: number = 34; // デフォルト値はタブレット横表示用の34
    if (matches2) {
        // スマホ縦表示
        dotsPerRow = 11;
    } else if (matches3) {
        // スマホ横表示
        dotsPerRow = 21;
    } else if (matches4) {
        // タブレット縦表示
        dotsPerRow = 25;
    }

    // (ドット数 ÷ 1行あたりのドット数) + 1(余白分)により
    // ドットの表示領域（データ量により可変）を決定
    const carouselDotRows = Math.floor(itemsNum / dotsPerRow) + 1;

    // ベースとなる高さ + (ドットエリアの行数 × ドット1行分の高さ)から
    // 最終的なカルーセル領域（カードエリア＋ドットエリア）を決定

    return `${baseHeight + carouselDotRows * HEIGHT_DOT_ROW}px`;
};
